import React, { Component, Fragment } from 'react'
import { Button } from '@driftt/tide'
import CustomLinkLists from '../CustomLinksList'
import CustomLinkForm from '../CustomLinkForm'

import { KB_USER_DEFINED_LINK_LIMIT } from 'modules/settings/model'

import { getCustomLinks, getCustomLink } from 'modules/settings/selectors'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from 'modules/settings/actions'

import { addhttps } from 'modules/settings/helpers'

import './style.css'

class CustomLinks extends Component {
  
  state = {
    showNewLinkForm: false,
    isEditingCustomLink: false
  }
  
  handleEditCustomLink = customLink => {
    this.setState({
      isEditingCustomLink: true
    }, () => {
      this.props.setCustomLink(customLink)
      this.toggleForm()
    })
  }
  
  handleRemoveCustomLink = customLink => {
    this.props.deleteCustomLink(customLink.id)
  }
  
  handleCancelForm = () => {
    this.setState({
      isEditingCustomLink: false
    }, () => {
      this.props.clearCustomLink()
      this.toggleForm()
    })
  }
  
  handleSaveForm = () => {
    const { isEditingCustomLink } = this.state
    const { selectedCustomLink } = this.props
    
    const { addedHttps, url } = addhttps(selectedCustomLink.url)
    
    if (addedHttps) {
      this.props.changeCustomLinkUrl(url)
    }
    
    isEditingCustomLink ? this.props.editCustomLink() : this.props.saveCustomLink()
    
    this.setState({
      isEditingCustomLink: false
    }, () => {
      this.props.clearCustomLink()
      this.toggleForm()
    })
  }
  
  handleUrlChange = e => this.props.changeCustomLinkUrl(e.target.value)
  
  handleDisplayTextChange = e => this.props.changeCustomLinkText(e.target.value)
  
  toggleForm = () =>
    this.setState(prevState => ({
      showNewLinkForm: !prevState.showNewLinkForm
    }))
  
  render() {
    const { showNewLinkForm } = this.state
    const { customLinks, selectedCustomLink } = this.props
    
    return (
      <div className="custom-links-wrapper">
        <h3 className="custom-links-header">{`Add up to ${KB_USER_DEFINED_LINK_LIMIT} custom links to your header`}</h3>
  
        {showNewLinkForm ?
          <CustomLinkForm
            onSave={this.handleSaveForm}
            onUrlChange={this.handleUrlChange}
            onDisplayTextChange={this.handleDisplayTextChange}
            onCancel={this.handleCancelForm}
            customLink={selectedCustomLink}
          /> :
          <Fragment>
            <CustomLinkLists
              customLinks={customLinks}
              onEditCustomLink={this.handleEditCustomLink}
              onRemoveCustomLink={this.handleRemoveCustomLink}
            />
            
            <Button
              icon="plus"
              iconAlignment="left"
              size="medium"
              type="tertiary"
              className="custom-links-add-button"
              onClick={this.toggleForm}
              disabled={customLinks.length >= KB_USER_DEFINED_LINK_LIMIT}
            >
              Add Custom Link
            </Button>
          </Fragment>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customLinks: getCustomLinks(state),
  selectedCustomLink: getCustomLink(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setCustomLink: actions.setSelectedCustomLink,
    clearCustomLink: actions.clearCustomLink,
    editCustomLink: actions.editCustomLink,
    deleteCustomLink: actions.deleteCustomLink,
    saveCustomLink: actions.saveCustomLink,
    changeCustomLinkUrl: actions.changeCustomLinkUrl,
    changeCustomLinkText: actions.changeCustomLinkText
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CustomLinks)